import EmailChartIcon from './EmailChartIcon';
export default EmailChartIcon;
